import React from 'react';
import { Card, Row, Table, Tooltip, Typography, Button } from 'antd';
import EditableSectionDevelopment from "./EditableSectionDevelopment";
import {AddRounded, DeleteForeverRounded} from "@mui/icons-material";

const { Title, Text, Paragraph } = Typography;

const ProficiencyRubricCard = ({
    proficiencyRubric,
    isEditMode,
    editingState,
    adaptedKeys,
    handleEdit,
    handleContentChange,
    handleSave,
    handleCancel,
    handleAddListItem,
    handleRemoveListItem,
    handleClearField
}) => {
    const rubricColumns = [
        {
            title: 'Level',
            dataIndex: 'levelName',
            key: 'levelName',
            width: '25%',
            render: (text, record, index) => {
                const contentKey = `proficiencyRubric.levels.${index}.levelName`;
                const isEditingThisOne = editingState.key === contentKey;
                return (
                    <EditableSectionDevelopment
                        contentKey={contentKey}
                        editContent={isEditingThisOne ? editingState.content : text}
                        isEditing={isEditingThisOne}
                        isAdapted={adaptedKeys.has(contentKey)}
                        onEdit={isEditMode ? handleEdit : undefined}
                        onChange={isEditMode ? handleContentChange : undefined}
                        onSave={isEditMode ? handleSave : undefined}
                        onCancel={isEditMode ? handleCancel : undefined}
                        component="span"
                    >
                        <Text strong>{text}</Text>
                    </EditableSectionDevelopment>
                );
            }
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            render: (text, record, index) => {
                const contentKey = `proficiencyRubric.levels.${index}.description`;
                const isEditingThisOne = editingState.key === contentKey;
                return (
                    <EditableSectionDevelopment
                        contentKey={contentKey}
                        editContent={isEditingThisOne ? editingState.content : text}
                        isEditing={isEditingThisOne}
                        isAdapted={adaptedKeys.has(contentKey)}
                        onEdit={isEditMode ? handleEdit : undefined}
                        onChange={isEditMode ? handleContentChange : undefined}
                        onSave={isEditMode ? handleSave : undefined}
                        onCancel={isEditMode ? handleCancel : undefined}
                        component="span"
                    >
                        <Text>{text}</Text>
                    </EditableSectionDevelopment>
                );
            }
        },
        {
            title: 'Action',
            key: 'action',
            width: '50px',
            render: (text, record, index) => (
                isEditMode && (
                    <Tooltip title="Remove level">
                        <Button
                            type="text"
                            danger
                            shape="circle"
                            icon={<DeleteForeverRounded />}
                            onClick={() => handleRemoveListItem(
                                'proficiencyRubric.levels',
                                index,
                                record.levelName || 'this level'
                            )}
                        />
                    </Tooltip>
                )
            )
        },
    ];

    return (
        <div id="lesson-rubric">
            <Row justify="space-between" align="middle">
                <Title level={2} style={{margin: 0}}>Proficiency Rubric</Title>
                {isEditMode && (
                    <Button
                        type="primary"
                        icon={<AddRounded />}
                        onClick={() => handleAddListItem(
                            'proficiencyRubric.levels',
                            () => ({ levelName: `New Level ${proficiencyRubric?.levels?.length + 1 || 1}`, description: 'Click to edit description' }),
                            'Rubric Level'
                        )}
                        title="Add Rubric Level"
                    >
                        Add Level
                    </Button>
                )}
            </Row>
            {proficiencyRubric && (
                <Card size="small" style={{ margin: "16px 0", background: '#fafafa' }}>
                    <EditableSectionDevelopment
                        contentKey='proficiencyRubric.assessedItem'
                        editContent={editingState.key === 'proficiencyRubric.assessedItem' ? editingState.content : proficiencyRubric.assessedItem}
                        isEditing={editingState.key === 'proficiencyRubric.assessedItem'}
                        isAdapted={adaptedKeys.has('proficiencyRubric.assessedItem')}
                        onEdit={isEditMode ? handleEdit : undefined}
                        onChange={isEditMode ? handleContentChange : undefined}
                        onSave={isEditMode ? handleSave : undefined}
                        onCancel={isEditMode ? handleCancel : undefined}
                        onDelete={isEditMode ? () => handleClearField('proficiencyRubric.assessedItem', 'Assessed Item') : undefined}
                        deleteTooltip="Clear assessed item"
                    >
                        <Paragraph style={{ margin: 0 }}>
                            <strong>Assessed Item:</strong> {proficiencyRubric.assessedItem || <Text type="secondary" italic>Not specified</Text>}
                        </Paragraph>
                    </EditableSectionDevelopment>
                </Card>
            )}

            <Table
                columns={rubricColumns}
                dataSource={proficiencyRubric?.levels || []}
                pagination={false}
                bordered
                size="small"
                rowKey="levelName"
            />
        </div>
    );
};

export default ProficiencyRubricCard;
